import { langIdOnLocale } from '../../../utils/LocaleUtil/languageList';
import { getCookie } from '../../../utils/CookieUtil';
import { addressFields } from '../../../utils/AddressUtil';

const buildContactPayload = (props) => {
    const {
        addPhoneToSecureListEnabled, emailOptOut,
        // contact information
        titleName, firstName, lastName, latinFirstName, latinLastName, email, locale, password,
        // phone number
        phoneCountryCode, phoneCountryCodeDigits, phoneNumber,
        // property information
        competitorUrl, legalName, propertyName, latinPropertyName, currency, propertyType,
        managerInfo, chainInfo, unitCount, websiteUrl,
        // address information
        address, placeId, latLngDetails, partialMatch, isAddressV2, isUnicode,
        // risk details
        fingerprint, useThreeLetterCountryCode,
        // props from the caller
        epcUserId, isPaperContractUser, source, lypsSalesforceExperiment,
        // salesforce information
        submarketId
    } = props;
    const trustPayload = window.trustApi.getTrustPayload();
    const langId = langIdOnLocale(locale);
    const atoShieldCaptchaToken = window['fc-token'];
    const type = 'HOTELIER';
    const duaid = getCookie('DUAID');

    const contact = {
        // join details
        type,
        addPhoneToSecureListEnabled,
        duaid,
        produceAccountCreatedEvent: true,
        source,
        emailOptOut,
        // contact information
        title: titleName,
        firstName,
        lastName,
        latinFirstName,
        latinLastName,
        email,
        locale,
        password,
        epcUserId,
        // phone number
        phoneCountryCode,
        phoneCountryCodeDigits,
        phoneNumber,
        // property information
        competitorUrl,
        ownerName: legalName,
        propertyName,
        latinPropertyName,
        currency,
        propertyType,
        managerInfo,
        chainInfo,
        unitCount,
        websiteUrl,
        // address information
        parsedAddress: addressFields(address, useThreeLetterCountryCode),
        placeId,
        latLngDetails,
        partialMatch,
        isAddressV2,
        isUnicode,
        // risk details
        langId,
        gaClientId: getCookie('_ga')?.split('.')?.slice(-2)?.join('.'),
        atoShieldCaptchaToken,
        fingerprint,
        trustPayload,
        autoContractSign: isPaperContractUser,
        salesForceFromLyps: lypsSalesforceExperiment === 1,
        salesForceInformation: submarketId ? {
            submarketId
        } : undefined
    };
    return contact;
};

export {
    // eslint-disable-next-line import/prefer-default-export
    buildContactPayload
};
